import { data } from "../../mockData/_products-mock";

import CallApi from "../../util/CallApi";

export const FETCH_PRODUCT = "FETCH_PRODUCT";
export const FETCH_PRODUCT_SUCCESS = "FETCH_PRODUCT_SUCCESS";
export const FETCH_PRODUCT_FAILURE = "FETCH_PRODUCT_FAILURE";

export const FILTER_PRODUCT = "FILTER_PRODUCT";
const mockup = false;
const callApi = new CallApi();

export const fetchProducts = params => dispatch => {
  dispatch({ type: FETCH_PRODUCT });
  if (mockup) {
    setTimeout(() => {
      return dispatch({ type: FETCH_PRODUCT_SUCCESS, payload: data });
    }, 1000);
  } else {
    return callApi
      .postWithOutToken("/product", params)
      .then(res => {
        dispatch({ type: FETCH_PRODUCT_SUCCESS, payload: res });
      })
      .catch(error => dispatch({ type: FETCH_PRODUCT_FAILURE }));
  }
};

export const filterProducts = brandList => dispatch => {
  dispatch({ type: FILTER_PRODUCT, payload: brandList });
};
